<template>
    <div class="service-package-footer">
        <ServicePackagePrice
            v-if="addon.name !== ServicePackageName.None"
            :price="addon.price"
            :originalPrice="addon.originalPrice"
            :showStrikethrough="showStrikethrough" />
        <div class="service-package-footer-actions">
            <ButtonPrimary v-if="isSelected" icon="Check">
                {{ t({ key: 'shared.selected', format: LabelFormat.Capitalize }) }}
            </ButtonPrimary>
            <ButtonSecondary v-else @click="$emit('select', true)">
                {{ t({ key: 'shared.choose', format: LabelFormat.Capitalize }) }}
            </ButtonSecondary>
        </div>
    </div>
</template>

<script lang="ts">
    import { computed, defineComponent, PropType } from 'vue';
    import { t } from '@shared/helpers/translation';
    import { LabelFormat } from '@shared/interfaces/translation';
    import {
        ServicePackage,
        ServicePackageName,
    } from '@ui/components/ServicePackage/ServicePackage.interfaces';
    import ButtonPrimary from '../../Button/ButtonPrimary.vue';
    import ButtonSecondary from '../../Button/ButtonSecondary.vue';
    import ServicePackagePrice from './ServicePackagePrice.vue';

    export default defineComponent({
        name: 'ServicePackageFooter',
        methods: { t },
        components: {
            ButtonPrimary,
            ButtonSecondary,
            ServicePackagePrice,
        },
        props: {
            addon: {
                type: Object as PropType<ServicePackage>,
                required: true,
            },
            isSelected: {
                type: Boolean,
                required: true,
            },
        },
        emits: ['select'],
        setup(props) {
            const showStrikethrough = computed(
                () => (props.addon.originalPrice?.Amount ?? 0) > props.addon.price.Amount
            );

            return {
                showStrikethrough,
                ServicePackageName,
                LabelFormat,
            };
        },
    });
</script>

<style scoped lang="scss">
    @forward '../ServicePackage.scss';
</style>
